import React from 'react';
import type { TwoColumnBlock as TwoColumnBlockType } from '../../../types';
import BlockRenderer from '../BlockRenderer';

type Props = {
    block: TwoColumnBlockType;
    depth: number;
};

const TwoColumnBlock: React.FC<Props> = ({ block, depth }) => (
    <div style={{ display: 'flex', gap: '1.6rem', margin: '0.8rem 0' }}>
        <div style={{ flex: 1 }}>
            <BlockRenderer blocks={block.left} depth={depth + 1} />
        </div>
        <div style={{ flex: 1 }}>
            <BlockRenderer blocks={block.right} depth={depth + 1} />
        </div>
    </div>
);
export default TwoColumnBlock;
